import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import apiClient from "../lib/api"
import { getAdminLoginPath } from "../lib/adminHost"
import {
  clearAdminSession,
  DUMMY_ADMIN_EMAIL,
  isDummyAuthToken,
} from "../lib/adminAuth"
import type { IAdminUser } from "@dc-ireland/shared"

export function useRequireAuth() {
  const [user, setUser] = useState<IAdminUser | null>(null)
  const [loading, setLoading] = useState(true)
  const [isDummySession, setIsDummySession] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    const checkAuth = async () => {
      const token = localStorage.getItem("auth_token")

      if (!token) {
        navigate(getAdminLoginPath())
        return
      }

      if (isDummyAuthToken(token)) {
        setUser({ email: DUMMY_ADMIN_EMAIL })
        setIsDummySession(true)
        setLoading(false)
        return
      }

      try {
        const response = await apiClient.getCurrentUser()
        setUser(response.user)
        setIsDummySession(false)
        localStorage.setItem("auth_scope", "admin")
      } catch (error) {
        console.error("Auth check failed:", error)
        clearAdminSession()
        navigate(getAdminLoginPath())
      } finally {
        setLoading(false)
      }
    }

    checkAuth()
  }, [navigate])

  const logout = async () => {
    if (!isDummyAuthToken(localStorage.getItem("auth_token"))) {
      try {
        await apiClient.logout()
      } catch (error) {
        console.error("Logout error:", error)
      }
    }

    clearAdminSession()
    navigate(getAdminLoginPath())
  }

  return { user, loading, logout, isDummySession }
}
